import React from 'react';
import { Navbar, Container } from 'react-bootstrap';

const Header = () => (
  <Navbar variant="light"  style={{ minHeight: "50px", minWidth: "370px", backgroundColor: "#E0BF01"}}>
    <Container style={{backgroundColor: "#E0BF01"}}>
      <Navbar.Brand style={{backgroundColor: "#E0BF01", fontWeight: 'bold', fontSize: '30px', display: 'flex', alignItems: 'center' }}>
        <a href="https://messageninja.ai">
          <img src="/Logo.png" alt="Logo" style={{height: '50px', marginRight: '10px' }}/>
        </a>
        <a href="https://messageninja.ai"style={{marginTop: '2px', color: 'black', textDecoration: 'none'}}>
          Message Ninja Growth
        </a>
      </Navbar.Brand>
    </Container>
  </Navbar>
);


export default Header;
